import { useQuery } from "@tanstack/react-query";
import queryKey from "../../enumerations/queryKey";
import { apiGetTGChannelLink } from "./service";

export const useGetTGChannelLink = ({ options }) => {
  return useQuery(
    [queryKey.TG_CHANNEL_LINK],
    () =>
      apiGetTGChannelLink({}).then((res) => {
        return res.data;
      }),
    {
      staleTime: 10 * (60 * 1000), //10mins
      cacheTime: 10 * (60 * 1000), //10mins
      ...options,
    },
  );
};
